import React from 'react';

function HowItWorks() {
  const steps = [
    {
      number: 1,
      title: 'Créez votre compte',
      description: 'Inscrivez-vous avec votre numéro de téléphone et complétez votre profil avec vos documents d\'identification.'
    },
    {
      number: 2,
      title: 'Obtenez un parrain',
      description: 'Recevez un code de parrainage d\'un membre existant ou contactez-nous pour être mis en relation.'
    },
    {
      number: 3,
      title: 'Achetez vos parts',
      description: 'Choisissez le nombre de parts sociales à acquérir et sélectionnez votre plan de paiement.'
    },
    {
      number: 4,
      title: 'Investissez et gagnez',
      description: 'Participez aux votes, investissez dans des projets et recevez vos dividendes régulièrement.'
    }
  ];

  return (
    <section className="how-it-works" id="how-it-works">
      <h2>Comment ça marche?</h2>
      <div className="steps">
        {steps.map((step) => (
          <div key={step.number} className="step">
            <div className="step-number">{step.number}</div>
            <div className="step-content">
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
